const theme = {
  // ── Colors ──────────────────────────────────────────────
  colors: {
    // Surfaces
    sidebarBg:        '#1E2630',
    sidebarBgHover:   '#2c3846',
    sidebarBgActive:  'rgba(255,255,255,.15)',
    bodyBg:           '#f5f7fa',
    surfaceWhite:     '#fff',
    surfaceSubtle:    '#f8fafc',
    surfaceLight:     '#f2f4f8',
    surfaceMuted:     '#eef1f5',

    // Text
    textPrimary:      '#1f2733',
    textSecondary:    '#6b7280',
    textTertiary:     '#8a93a1',
    textMuted:        '#9aa3b0',
    textOnDark:       '#fff',
    textOnDarkMuted:  'rgba(255,255,255,.75)',
    textOnDarkFaint:  'rgba(255,255,255,.6)',
    textOnDarkDim:    'rgba(255,255,255,.45)',

    // Accent (teal)
    accentTeal:       '#0f8994',
    accentTealHover:  '#14a3ae',
    accentTealLight:  '#35bfcb',
    accentTealBg:     '#e7f6f7',
    accentTealBgDark: '#c7ecef',

    // Links
    link:             '#1f6ff0',
    linkHover:        '#1858c9',

    // Semantic
    danger:           '#e5484d',
    dangerBg:         '#fdeceb',
    success:          '#22c55e',

    // Primary CTA (dark button)
    primaryBtn:       '#1E2630',
    primaryBtnHover:  '#2c3846',

    // Borders
    border:           '#e7eaf0',
    borderLight:      '#eceff3',
    borderMedium:     '#e6e9ee',
    borderDark:       '#dfe3ea',
    borderInput:      '#d3d8e0',
    sidebarDivider:   'rgba(255,255,255,.1)',

    // Disabled
    disabled:         '#c2c8d2',
    disabledText:     '#aeb6c2',
  },

  // ── Typography ──────────────────────────────────────────
  fontFamily: "'Plus Jakarta Sans', system-ui, -apple-system, BlinkMacSystemFont, sans-serif",

  fontSizes: {
    micro:    '10px',
    xs:       '11px',
    xsLabel:  '11.5px',
    sm:       '12px',
    smBody:   '12.5px',
    base:     '13px',
    md:       '13.5px',
    body:     '14px',
    lg:       '15.5px',
    xl:       '16px',
    '2xl':    '18px',
    '3xl':    '19px',
    '4xl':    '22px',
    '5xl':    '25px',
    '6xl':    '27px',
  },

  fontWeights: {
    medium:    500,
    semibold:  600,
    bold:      700,
    extrabold: 800,
  },

  letterSpacings: {
    tight:     '-.6px',
    snug:      '-.5px',
    normal:    '.4px',
    wide:      '1.2px',
    wider:     '1.3px',
    widest:    '2.5px',
  },

  // ── Spacing ─────────────────────────────────────────────
  spacing: {
    xs:   '4px',
    sm:   '8px',
    md:   '12px',
    lg:   '16px',
    xl:   '20px',
    '2xl': '24px',
    '3xl': '28px',
    '4xl': '34px',
    '5xl': '40px',
  },

  // ── Borders & Radii ────────────────────────────────────
  radii: {
    sm:    '6px',
    md:    '8px',
    lg:    '9px',
    xl:    '10px',
    '2xl': '11px',
    '3xl': '12px',
    '4xl': '14px',
    full:  '50%',
  },

  // ── Shadows ─────────────────────────────────────────────
  shadows: {
    card:     '0 1px 3px rgba(0,0,0,.04)',
    button:   '0 6px 16px -6px rgba(30,38,48,.45)',
    dropdown: '0 16px 38px -12px rgba(0,0,0,.5)',
    modal:    '0 24px 60px -12px rgba(0,0,0,.5)',
    teal:     '0 12px 26px -16px rgba(20,163,174,.55)',
  },

  // ── Layout ──────────────────────────────────────────────
  sidebar: {
    width:     '240px',
    railWidth: '68px',
  },
};

export default theme;
